export const PHASE_1_STUDENT_CANCEL_PENALTY_TRIGGER_SECONDS = 60 * 60
export const PHASE_1_STUDENT_CANCEL_PENALTY_DURATION_HOURS = 36
export const PHASE_1_STUDENT_NOSHOW_PENALTY_DURATION_HOURS = 72

export type StudentCancelPenaltyPolicyPhase = 'PHASE_1'
export type Phase1StudentPenaltyEvent = 'CANCEL' | 'NOSHOW'

export const getStudentCancelPenaltyPolicyPhase = (): StudentCancelPenaltyPolicyPhase => {
  return 'PHASE_1'
}

export const getStudentCancelPenaltyTriggerSeconds = (_phase: StudentCancelPenaltyPolicyPhase): number => {
  return PHASE_1_STUDENT_CANCEL_PENALTY_TRIGGER_SECONDS
}

export const getStudentCancelPenaltyDurationHours = (_phase: StudentCancelPenaltyPolicyPhase): number => {
  return PHASE_1_STUDENT_CANCEL_PENALTY_DURATION_HOURS
}

export const getPhase1StudentPenaltyDurationHours = (event: Phase1StudentPenaltyEvent): number => {
  return event === 'CANCEL'
    ? PHASE_1_STUDENT_CANCEL_PENALTY_DURATION_HOURS
    : PHASE_1_STUDENT_NOSHOW_PENALTY_DURATION_HOURS
}

export const isStudentCancelPenaltyRequired = ({
  classStartUnix,
  confirmedAtUnix,
  policyPhase,
}: {
  classStartUnix: number
  confirmedAtUnix: number
  policyPhase: StudentCancelPenaltyPolicyPhase
}): boolean => {
  const secondsUntilStart = classStartUnix - confirmedAtUnix
  const triggerSeconds = getStudentCancelPenaltyTriggerSeconds(policyPhase)

  return secondsUntilStart < triggerSeconds
}

export const isStudentCancelPenaltyRequiredForConfirmedCancel = ({
  classStartUnix,
  confirmedAtUnix,
}: {
  classStartUnix: number
  confirmedAtUnix: number
}): boolean => {
  return isStudentCancelPenaltyRequired({
    classStartUnix,
    confirmedAtUnix,
    policyPhase: getStudentCancelPenaltyPolicyPhase(),
  })
}

export const isStudentLessonChangeNotAllowed = ({
  classStartUnix,
  confirmedAtUnix,
  policyPhase,
}: {
  classStartUnix: number
  confirmedAtUnix: number
  policyPhase: StudentCancelPenaltyPolicyPhase
}): boolean => {
  const secondsUntilStart = classStartUnix - confirmedAtUnix
  const triggerSeconds = getStudentCancelPenaltyTriggerSeconds(policyPhase)

  return secondsUntilStart <= triggerSeconds
}
